<template>
  <div>
    <Slider
      v-if="showSlider"
      ref="Slider"
      direction="vertical"
      :mousewheel-control="true"
      :performance-mode="true"
      :pagination-visible="true"
      :pagination-clickable="true"
      :loop="true"
      :speed="500"
      @slide-change-start="onSlideChangeStart"
      @slide-change-end="onSlideChangeEnd"
      class="loaderBackground"
      v-bind:style="{ 'background-image': 'url(' + post.POST_CONTENT[0] + ')' }"
      :interval="5000"
      :auto="false"
    >
      <div
        v-for="(x, index)  in post.POST_CONTENT"
        :key="index"
        v-bind:style="{ 'background-image': 'url(' + x + ')' }"
        v-bind:class="{ firstSlide : (index === 0), secondSlide : (index === 1) }"
      >
        <div v-if="index === 1" class="fullPageContent projekt">
          <div v-html="post.POST_TEXT ? post.POST_TEXT : ''" class></div>
        </div>
      </div>
    </Slider>
    <transition name="slide-fade">
      <div class="bottomText" v-if="LastSlide" v-html="single.POST_CONTENT"></div>
    </transition>
    <div class="arrowSlider" v-bind:class="{ directionClass: directionUp }" @click="arrowSlider()">
      <img src="/img/a.png" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Slider from "vue-plain-slider";
const fetchInitialData = (store, route) => {
  return store.dispatch(`page/getPost`, route.params.page);
};
const fetchInitialData2 = (store, route) => {
  return store.dispatch(`page/getPage`, "tekst-na-dole-w-projektach");
};
export default {
  components: { Slider },
  data() {
    return {
      showSlider: false,
      showText: false,
      directionUp: false,
      clicked: false,
      LastSlide: false
    };
  },
  computed: {
    ...mapGetters("page", ["postIsLoading"]),
    post() {
      return this.$store.state.page.post;
    },
    single() {
      return this.$store.state.page.single;
    }
  },
  methods: {
    arrowSlider() {
      var self = this;
      if (!self.clicked) {
        self.clicked = true;
        if (this.directionUp) {
          this.$refs.Slider.prev();
        } else {
          this.$refs.Slider.next();
        }
        setTimeout(function() {
          self.clicked = false;
        }, 1000);
      }
    },
    onSlideChangeStart(currentPage, el) {},
    onSlideChangeEnd(currentPage, el) {
      var self = this;
      if (currentPage === 2) {
        setTimeout(function() {
          self.showText = true;
        }, 1);
      } else {
        self.showText = false;
      }
      if (self.post.POST_CONTENT.length === currentPage) {
        self.directionUp = true;
        self.LastSlide = true;
      } else {
        self.LastSlide = false;
      }
      if (currentPage === 1) {
        self.directionUp = false;
      }
    },
    ...mapActions("page", {
      getPost: "getPost"
    }),
    loadData() {
      fetchInitialData(this.$store, this.$route);
      fetchInitialData2(this.$store, this.$route);
    }
  },
  watch: {
    post: function(npost) {
      this.showSlider = true;
    },
    $route(to, from) {
      this.loadData();
    }
  },
  prefetch: fetchInitialData,
  mounted() {
    this.loadData();

    const element = document.getElementById("page");
    element.classList.add("addAnimation");
  },
  beforeCreate: function() {
    document.body.classList.add("invertedHeader");
    document.body.classList.add("redBackground");
  },
  beforeDestroy: function() {}
};
</script>

<style lang="scss">
.slider {
  width: 100vw;
  height: 100vh;
}
.slider-wrap > div {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.loaderBackground {
  background-size: cover;
}
.firstSlide {
  background-position: center;
  background-image: none !important;
}
.secondSlide {
  background-image: none !important;
}
.bottomText {
  text-align: center;
  width: 100%;
  color: #fff;
  padding: 20px 20px 15px 20px;
  position: fixed;
  bottom: 60px;
  a {
    text-decoration: none;
  }
}
.arrowSlider {
  transition: all 1s linear;
  border: 1px solid #fff;
  position: fixed;
  bottom: 20px;
  width: 36px;
  height: 36px;
  margin-left: -18px;
  cursor: pointer;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.2;
  }
  img {
    width: 15px;
    height: 15px;
  }
  &.directionClass {
    transform: rotate(180deg);
  }
}
</style>
